import { render, staticRenderFns } from "./ScaleTemplate.vue?vue&type=template&id=54494868&scoped=true"
import script from "./ScaleTemplate.vue?vue&type=script&lang=js"
export * from "./ScaleTemplate.vue?vue&type=script&lang=js"
import style0 from "./ScaleTemplate.vue?vue&type=style&index=0&id=54494868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54494868",
  null
  
)

export default component.exports